const ConstVar={
    //DATE_FORMAT:"DD-MM-YYYY",
    DATE_FORMAT:"MM-DD-YYYY",
    TIME_FORMAT:"HH:mm:ss",
};
export default ConstVar;